/** Tiny typed wrapper around localStorage; never throws. */
export function load<T>(key: string, fallback: T): T {
  try {
    const raw = localStorage.getItem(key);
    return raw == null ? fallback : (JSON.parse(raw) as T);
  } catch {
    return fallback;
  }
}

export function save(key: string, value: unknown): void {
  try {
    if (value === undefined || value === null) localStorage.removeItem(key);
    else localStorage.setItem(key, JSON.stringify(value));
  } catch {
    /* storage unavailable */
  }
}

/** Remove every key starting with one of these prefixes (sign-out). */
export function clearPrefixes(...prefixes: string[]): void {
  try {
    for (const key of Object.keys(localStorage)) if (prefixes.some((p) => key.startsWith(p))) localStorage.removeItem(key);
  } catch {
    /* storage unavailable */
  }
}
